import { render, staticRenderFns } from "./message-nav.vue?vue&type=template&id=328900a2&scoped=true"
import script from "./message-nav.vue?vue&type=script&lang=js"
export * from "./message-nav.vue?vue&type=script&lang=js"
import style0 from "./message-nav.vue?vue&type=style&index=0&id=328900a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328900a2",
  null
  
)

export default component.exports